import {apiClient} from 'common/util/api-client';
import {Results} from 'app_api/projects/banners/types';

export interface GetBannersRequest {
  projectId: string;
  workspaceId?: string;
  reportName: string;
}

export type GetBannersResponse = Results;

export function getBanners(params: GetBannersRequest): Promise<GetBannersResponse> {
  const {projectId, workspaceId, reportName} = params;
  const queryParams = {report: reportName};
  const bannersApiUrl = `/api/app/${workspaceId ? `workspaces/${workspaceId}` : `projects/${projectId}`}/banners`;
  return apiClient.get(bannersApiUrl, queryParams);
}
